export default {
  computed: {
    mainTitle() {
      const product = this.mainProduct || this.product;
      return product.season?.serial?.title || product.title;
    },
  },
};
